import { useEffect, useRef, useState } from "react";
import { Button, Checkbox, styled, Typography } from "@mui/material";
import { HeaderComponent } from "./cheaqueComponents/components";
import PassedCheque from "./cheaqueComponents/PassedCheque";
import Chequecomponent from "./cheaqueComponents/Chequecomponent";
import PassedChequeForm from "./cheaqueComponents/PassedChequeForm";
import TransferedChequeForm from "./cheaqueComponents/TransferedChequeForm";
import ReturnedChequeForm from "./cheaqueComponents/ReturnedChequeForm";
import { Form, Formik } from "formik";
import { apiChequeChangeStatus } from "api/chequeApi";
import { addOpenDrawer } from "store/actions/appAction";
import DepositReceiptChequeForm from "./cheaqueComponents/DepositReceiptChequeForm";
import NormalChequeForm from "./cheaqueComponents/NormalChequeForm";
import { useAppDispatch, useAppSelector } from "store/store";
import ReactToPrint from "react-to-print";
import BasicButton from "../../BasicInputs/BasicButton";
import PrinterIcon from "assets/icons/PrinterIcon";
import axios from "../../../axios/axios";
import useChequePrint from "./useChequePrint";

const RecieveCheckBody = styled("div")(({ theme }) => ({
  padding: "12px 16px",
}));
const DrawerContainer = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  height: "fit-content",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  paddingBottom: "12px",
}));
const ActionButton = styled(Button)(({ theme }) => ({
  width: "350px",
}));
const ButtonContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
}));

const SelectContainer = styled("div")(({ theme }) => ({
  margin: "19px 12px 0 12px",
  minHeight: "100px",
}));

interface ChequeFormItems {
  label: string;
  name: string;
  Component: (props: any) => JSX.Element;
  status: string;
  key: string;
}

const getItems = (type?: string): ChequeFormItems[] => {
  return [
    {
      label: "عادی",
      name: "normal",
      Component: NormalChequeForm,
      status: "normal",
      key: "normal",
    },
    {
      label: "پاس شده",
      name: "passed",
      Component: PassedChequeForm,
      status: type === "receive" ? "receiveReceipt" : "paidReceipt",
      key: "receipt",
    },
    {
      label: "واگذاری به بانک",
      name: "transfered",
      Component: TransferedChequeForm,
      status: "deposit",
      key: "deposit",
      // status: type === 'receive' ? 'depositReceipt' : 'deposit'
    },
    {
      label: "عودت",
      name: "returned",
      Component: ReturnedChequeForm,
      status: type === "receive" ? "receiveRefund" : "paidRefund",
      key: "refund",
    },
    {
      label: "وصول شده",
      name: "depositReceipt",
      Component: DepositReceiptChequeForm,
      status: "depositReceipt",
      key: "depositReceipt",
    },
    //this is for spent cheques to convert them to normal
    {
      label: "عادی",
      name: "spent",
      Component: NormalChequeForm,
      status: "spent",
      key: "spent",
    }
  ];
};

interface CheckboxInteface {
  active?: boolean;
}

const CheckboxContainer = styled("div")(({ theme }) => ({
  display: "flex",
  height: "40px",
  alignItems: "center",
}));
const ItemContainer = styled("div")<CheckboxInteface>(({ theme, active }) => ({
  display: "flex",
  flexDirection: "column",
  borderRadius: "6px",
  boxShadow: active ? "0px 4px 12px rgba(25, 25, 26, 0.03)" : "",
  border: active ? "1px solid #E1EAF5" : "",
}));

const ChequeDrawer = () => {
  const dispatch = useAppDispatch();
  const store = useAppSelector((state: any) => state);
  const { drawerProps } = store.appReducer;
  const { cheque } = drawerProps;
  const { token } = store.businessReducer.business;
  const [loading, setLoading] = useState(false)
  const items = getItems(cheque?.type);
  const [checked, setChecked] = useState<(typeof items)[0] | undefined>(undefined);
  const initialValues = {};
  const [chequeShow, setChequeShow] = useState<any>({})
  const contentRef = useRef<any>(null);

  useEffect(() => {
    const getCheque = async (id: number) => {
      axios.get(`cheques/${id}`,
        { headers: { Authorization: `Bearer ${token}` } }
      ).then((response) => {
        console.log(`chequeItem is: ${JSON.stringify(response.data.cheque)}`)
        setChequeShow(response.data.cheque)
      })
        .catch((error) => {
          console.log(`error is:${error}`)
        })
    }
    getCheque(cheque.id)
  }, [cheque]);

  const handleChange = (name: string) => {
    const foundedItem = items.find((item) => item.name === name);
    if (foundedItem?.name === checked?.name) return setChecked(undefined);
    return setChecked(foundedItem);
  };

  const { Component, status } = checked ? checked : { Component: () => <div></div>, status: "" };

  const onSubmit = (values: any) => {
    setLoading(true)
    dispatch(
      apiChequeChangeStatus(
        cheque?.id,
        token,
        status,
        { ...values, typeId: values.type?.id, type: values?.type?.type },
        callback
      )
    );
  };

  const callback = () => {
    setLoading(false)
    return dispatch(addOpenDrawer(false));
  };
  const { cheqRef, chequeContent } = useChequePrint({
    cheque: {
      amount: chequeShow.amount, dueDate: chequeShow.dueDate, id: chequeShow.id,
      inCash: chequeShow.payTo,
      nationalId: chequeShow.type === "payment" ? chequeShow.received?.nationalId : ""


    }
  })
  //ojaghiadded
  return (
    <Formik initialValues={initialValues} onSubmit={onSubmit}>
      {(formik) => (
        <Form>
          <DrawerContainer>
            <div>
              <HeaderComponent />
              {checked && <PassedCheque cheque={cheque} />}
              {!checked && <Chequecomponent cheque={cheque} />}
              {cheque && (
                <RecieveCheckBody>
                  <div className="hidden">{chequeContent}</div>
                  <ReactToPrint
                    ref={contentRef}
                    trigger={() => (
                      <BasicButton fullWidth variant="contained" style={{ gap: "20px", width: 150 }}>
                        <PrinterIcon />
                        <span>چاپ چک</span>
                      </BasicButton>
                    )}
                    content={() => cheqRef.current}
                  />
                  {drawerProps?.disableAction ? null : (
                    <SelectContainer>
                      <Typography sx={{ marginBottom: "16px" }} variant="body2" color="text.disabled">
                        تغییر وضعیت چک:
                      </Typography>
                      {cheque.actions?.map((action: any, key: number) => {
                        const item = items.find((i) => i.key === action);
                        return (
                          item && (
                            <ItemContainer key={key} active={item.name === checked?.name}>
                              <CheckboxContainer key={item.name}>
                                <Checkbox
                                  checked={item.name === checked?.name}
                                  onClick={() => handleChange(item.name)}
                                />
                                <Typography sx={{ marginRight: "10px" }} variant="body2">
                                  {item.label}
                                </Typography>
                              </CheckboxContainer>
                              {item.name === checked?.name && <Component cheque={cheque} {...item} />}
                            </ItemContainer>
                          )
                        );
                      })}
                    </SelectContainer>
                  )}
                </RecieveCheckBody>
              )}
            </div>
            {drawerProps?.disableAction
              ? null
              : cheque &&
              (
                <ButtonContainer>
                  <ActionButton
                    onClick={() => onSubmit(formik.values)}
                    type="submit"
                    disabled={loading}
                    fullWidth
                    disableRipple
                    disableFocusRipple
                    disableTouchRipple
                    variant="contained"
                    color="primary"
                    disableElevation
                  >
                    ثبت تغییرات
                  </ActionButton>
                </ButtonContainer>
              )}
          </DrawerContainer>
        </Form>
      )}
    </Formik>
  );
};

export default ChequeDrawer;
